export default {
  EVENT: {
    ALL: 'all',
    ON_GOING: 'on-going',
    COMING_SOON: 'coming-soon',
    HISTORY: 'history',
    EVENT_DATE: 'eventDate'
  }
}
